import { useMutation } from "react-query";
import { postAuthOTPSend } from "../../../queries/auth";
import { coreService } from "../../../services/coreService";
import { FirstArgumentType } from "../../../types/ArgumentTypes";
import { useAnonymousTokenNetworkHeaders } from "./useAnonymousTokenNetworkHeaders";

export function useAuthOTPSend({
  onSuccess = () => {},
  onError = () => {},
}: {
  onSuccess?: (data: Awaited<ReturnType<ReturnType<typeof postAuthOTPSend>>>) => void;
  onError?: (error: unknown, message: string) => void;
} = {}) {
  const networkHeaders = useAnonymousTokenNetworkHeaders();

  const [authOTPSendMutation, { isLoading: isAuthOTPSendLoading }] = useMutation(postAuthOTPSend(networkHeaders), {
    onSuccess,
    onError: (error) => {
      if ((error as any).status === 429) {
        const message = (error as any).error.message;
        onError(error, message);
      } else {
        onError(error, "An unknown error occurred while sending one-time password");
      }
    },
  });

  const sendAuthOTP = async (body: FirstArgumentType<typeof coreService.authOtpSendCreate>) => {
    return await authOTPSendMutation(body);
  };

  return { sendAuthOTP, isAuthOTPSendLoading };
}
